/**
 * Web useSafeAreaInsets Hook
 *
 * Returns zero insets on web since there are no system UI overlays.
 */

import type { SafeAreaInsets } from "./types";

export function useSafeAreaInsets(): SafeAreaInsets {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };
}
